import {
	ElibraryListDataSource, Question
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyLocalDatabase } from "./idb";
import { Serializer } from "@sabyr-dev/mist_core/model/datasource";
import { ListItem } from "@sabyr-dev/mist_core/model/datasource/list";
import { AcademyAttemptState } from "./state";

export class AcademyListDataSource extends ElibraryListDataSource {
	local: AcademyLocalDatabase;

	constructor(item: Serializer<Question>) {
		super(item);
		this.local = new AcademyLocalDatabase();
	}

	async getItemList(): Promise<ListItem<Question>[]> {
		const db = await this.local.getDb();
		const state = await db.get(AcademyLocalDatabase.attempt, this.local.getAttemptKey()) as AcademyAttemptState;
		const items = Array.from(
			document.querySelectorAll<HTMLElement>('.item-list .item')
		).map((element: HTMLElement) => this.makeListItem(element.dataset))
			.map(item => ({
				...item,
				...(state?.userData && item.id in state.userData ? state.userData[item.id] : {})
			}));
		return items;
	}
}
